import React from 'react';

export default (loader, collection, loading) => (
  class AsyncContainer extends React.Component {
    constructor(props) {
      super(props);
      this.state = { Container: AsyncContainer.Container };
    }

    componentDidMount() {
      this._isMounted = true
      if (!this.state.Container) {
        loader().then((Container) => {
          if (this._isMounted === true) {
            this.setState({ Container })
          }
        })
      }
    }

    componentWillUnmount() {
      this._isMounted = false
    }

    render() {
      if (this.state.Container) {
        return (
          <this.state.Container { ...this.props } { ...collection } />
        )
      }
      else if (loading !== undefined) {
        return (
          <React.Fragment>
            {loading}
          </React.Fragment>
        )
      }
      return null;
    }
  }
);


// WEBPACK FOOTER //
// ./src/containers/Common/AsyncContainer.js